import styled from 'styled-components';

export const InfoBox = styled.div`
  padding: 16px;
  background: #f0f9ff;
  border: 1px solid #bae6fd;
  border-radius: 8px;
  margin-bottom: 20px;

  h3 {
    font-size: 14px;
    font-weight: 600;
    color: #0369a1;
    margin: 0 0 8px 0;
  }

  p {
    font-size: 13px;
    color: #075985;
    margin: 0 0 8px 0;
    line-height: 1.5;
  }

  code {
    background: #e0f2fe;
    padding: 2px 6px;
    border-radius: 4px;
    font-size: 12px;
    font-family: 'Courier New', monospace;
  }
`;

export const SuccessBox = styled.div`
  padding: 16px;
  background: #dcfce7;
  border: 1px solid #86efac;
  border-radius: 8px;
  margin-bottom: 20px;
  display: flex;
  align-items: center;
  gap: 12px;

  i {
    font-size: 24px;
    color: #166534;
  }

  p {
    font-size: 14px;
    color: #166534;
    margin: 0;
    font-weight: 600;
  }
`;

export const ErrorBox = styled.div`
  padding: 16px;
  background: #fee2e2;
  border: 1px solid #fca5a5;
  border-radius: 8px;
  margin-bottom: 20px;
  display: flex;
  align-items: start;
  gap: 12px;

  i {
    font-size: 24px;
    color: #991b1b;
  }

  div {
    flex: 1;
  }

  p {
    font-size: 14px;
    color: #991b1b;
    margin: 0;
    font-weight: 600;
  }
`;

